<template>
    <v-container fluid grid-list-md>
        <v-container grid-list-md fluid class="pt-0 pb-0 pl-0 pr-0" text-xs-right>
            <v-layout row wrap>
                <v-flex xs12 xl12>
                    <p class="text-xs-left display-1 mb-4 pt-4">
                        {{$t('postPaidPackageList') | capitalize}}
                        <v-btn icon>
                            <v-icon @click="loadPackages">refresh</v-icon>
                        </v-btn>
                    </p>
                </v-flex>
            </v-layout>
        </v-container>
        <v-layout row>
            <v-layout row wrap class="mx-0">
                <v-flex xs12 md6 lg3>
                    <v-autocomplete
                        v-model="dataFilters.project"
                        item-text="name"
                        item-value="id"
                        :label="$filters.capitalize($t('project'))"
                        :items="projectList"
                        clearable
                    ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md6 lg3>
                    <v-select
                        v-model="dataFilters.api"
                        label="API"
                        item-text="name"
                        item-value="id"
                        :items="apiList"
                        clearable
                    ></v-select>
                </v-flex>
                <v-flex xs12 md6 lg3>
                    <v-select
                        v-model="dataFilters.type"
                        :label="$filters.capitalize($t('packageType'))"
                        :items="postpaidTypeList"
                        clearable
                    ></v-select>
                </v-flex>
                <v-flex xs12 md6 lg3>
                    <v-select
                        v-model="dataFilters.status"
                        :label="$filters.capitalize($t('status'))"
                        :items="packageStatusList"
                        clearable
                    ></v-select>
                </v-flex>
            </v-layout>
            <div>
                <v-checkbox
                    v-model="dataFilters.viewCanceled"
                    :label="$filters.capitalize($t('postpaidRelated.canceled'))"
                ></v-checkbox>
            </div>
        </v-layout>
        <SimpleDataTable
            :headers="headers"
            :items="dataTable"
            :pagination.sync="pagination"
            :custom-sort="customSort"
            @row-click="toPageDetails($event)"
        >
            <template v-slot:status="props">
                <div class="status" :class="props.item.status">
                    {{$t('postpaidRelated.' + props.item.status) | toCapitalize}}
                </div>
            </template>
            <template v-slot:unitPrice="props">
                <v-layout
                    row
                    align-center
                    fill-height
                    justify-space-between
                    v-if="props.item.config.unit_price && Array.isArray(props.item.config.unit_price)"
                >
                    <table class="unit-price">
                        <tr :set="item = props.item.config.unit_price[props.item.config.unit_price.length - 1]">
                            <td>
                                <div>{{item.start | formatNumber}}</div>
                            </td>
                            <td>
                                <div class="font-weight-bold">{{item.price}} {{item.unit}}</div>
                            </td>
                        </tr>
                    </table>
                    <div style="width: 20px" v-if="props.item.limit_type === $const.NO_LIMIT_USAGE">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-icon small v-on="on">mdi-help-circle</v-icon>
                            </template>
                            <span>
                                <table class="unit-price unit-price-tooltip">
                                    <tr v-for="item in props.item.config.unit_price" :key="item.start">
                                        <td>
                                            <div>{{item.start | formatNumber}}</div>
                                        </td>
                                        <td>
                                            <div class="font-weight-bold">{{item.price}} {{item.unit}}</div>
                                        </td>
                                    </tr>
                                </table>
                            </span>
                        </v-tooltip>
                    </div>
                </v-layout>
                <span v-else>{{$t('error')}}</span>
            </template>
        </SimpleDataTable>
        <PostPaidPackageDetails ref="PostPaidPackageDetails"></PostPaidPackageDetails>
    </v-container>
</template>
<script>
import { mapState } from 'vuex'
import PostPaidPackageDetails from '@/views/Sales/PostPaidPackageDetails'
import SimpleDataTable from '@/modules/fptai/components/SimpleDataTable'
import ProjectService from '@/services/project.service'
import PostPaidPackageList from '@/views/Sales/PostPaidPackageList'
import _ from 'lodash'

export default {
    name: 'PostPaidPackageHistory',
    components: { SimpleDataTable, PostPaidPackageDetails },
    mixins: [PostPaidPackageList],
    computed: {
        ...mapState({
            currentProjectId: state => state.user.currentProjectId
        })
    },
    methods: {
        loadProjects () {
            ProjectService.getProjects(this.$const.projectType.POSTPAID).then(
                result => {
                    this.projectList = result.data
                },
                this.$appService.handleRequestError(this.$t('canNotLoadExistedProject'))
            )
        },
        loadPackages () {
            if (this.updating) {
                this.fireUpdate = true
                return
            }
            this.updating = true
            this.$appService.showLoading()
            ProjectService.getPostPaidPackage(this.dataFilters, this.pagination).then(
                result => {
                    this.pagination.totalItems = result.data.count
                    this.dataTable = result.data.results.map(item => {
                        try {
                            item.config = JSON.parse(item.config)
                        } catch (e) {
                            item.config = {
                                limit: null,
                                unit_price: []
                            }
                        }
                        return item
                    })
                },
                this.$appService.handleRequestError(this.$t('canNotLoadPostPaidPackage'))
            ).finally(() => {
                this.updating = false
                if (this.fireUpdate) {
                    this.fireUpdate = false
                    this.loadPackages()
                    return
                }
                this.$appService.hideLoading()
            })
        }
    },
    watch: {
        projects: {
            immediate: true,
            handler: function (projects) {
                if (_.find(projects, item => item.id === this.currentProjectId)) {
                    this.dataFilters.project = this.currentProjectId
                }
            }
        }
    }
}
</script>
<style scoped lang="scss">
    /deep/ table.v-table {
        tr {
            th, td {
                padding: 5px 0px 5px 15px;

                &:last-child {
                    padding-right: 5px;
                }
            }

            td {
                height: auto;
            }
        }
    }

    table.unit-price {
        border-collapse: collapse;

        tr {
            border: none !important;
        }

        tr td {
            padding: 0;

            div {
                padding: 0 5px;
                border-top: 1px solid #DFDFE4;
                border-bottom: 1px solid #DFDFE4;
                margin-bottom: 5px;
                background: #F0F0F0;
                white-space: nowrap;
            }

            &:first-child {
                div {
                    border-left: 1px solid #DFDFE4;
                    border-top-left-radius: 4px;
                    border-bottom-left-radius: 4px;
                }
            }

            &:last-child {
                div {
                    border-right: 1px solid #DFDFE4;
                    border-top-right-radius: 4px;
                    border-bottom-right-radius: 4px;
                }
            }
        }
    }

    table.unit-price-tooltip tr td div {
        background: rgba(0, 0, 0, 0);
        border: none;
        border-radius: 0;
    }

    .status {
        height: 20px;
        width: 80px;
        border-radius: 4px;
        font-size: 12px;
        color: #fff;
        text-transform: capitalize;
        display: flex;
        align-items: center;
        justify-content: center;

        &.canceled {
            background: #BFBFBF;
        }

        &.completed {
            background: #6DBE89;
        }

        &.active {
            background: #1D8BF1;
        }

        &.waiting {
            background: #FFB100;
        }

        &.draft {
            background: #797979;
        }
    }

    .icon-container i {
        margin-right: 5px;
    }
</style>
